import moment from 'moment';
export default {
	isSaved: false,
	isPqyUser: false,
	powCdList: [],
	resultList: [],
	badClCdList: [],
	badScnCdList: [],
	selectedRow: SELECTED_ROW(),
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO()
};

function SELECTED_ROW() {
	return {
		overSrgNo: '',
		rgnId: '',
		badSbc: '',
		badCause: '',
		badId: '',
		badClCd: '',
		badScnCd: '',
		partNo: '',
		partNm: '',
		occuDd: '',
		powCd: '',
		occuQty: ''
	};
}

function SEARCH_PARAMS() {
	return {
		strDt: moment().subtract(1, 'months').format('YYYY-MM-DD'),
		endDt: moment().format('YYYY-MM-DD'),
		partNo: '',
		rgnId: '',
		rgnNm: '',
		powCd: '',
		badClCd: '',
		badScnCd: '',
		serialNo:''
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 30,
		startPage: 1,
		totalSize: 1
	};
}
export { SEARCH_PARAMS, PAGING_INFO, SELECTED_ROW };
